export default "__VITE_ASSET__96ef9bd1__"